import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	selectedCrud: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	loadingDetails: false,
	modelCrudLoading: false,
};

const crudSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setCrudLoading: (state, action) => {
			state.loading = action.payload;
		},
		setCrudData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;
			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
			state.loading = false;
		},
		setModelsTransactionsCrudLoading: (state, action) => {
			state.modelCrudLoading = action.payload;
		},
		setModelsTransactionsCrudData: (state, action) => {
			const { models, transactions } = action.payload; // Destructure models and transactions

			state.models = models || [];
			state.transactions = transactions || [];
			state.modelCrudLoading = false;
		},
		setSelectedCrud: (state, action) => {
			state.selectedCrud = action.payload;
		},
		setDetailsLoading: (state, action) => {
			state.loadingDetails = action.payload;
		},
	},
});

export const {
	setCrudLoading,
	setCrudData,
	setModelsTransactionsCrudLoading,
	setModelsTransactionsCrudData,
	setSelectedCrud,
	setDetailsLoading,
} = crudSlice.actions;
export default crudSlice.reducer;
